define('v3/Common/Models/LazyLoadItem',[
	'knockout',
	'knockout-on-demand-observable'
], function (ko) {
	function LazyLoadItem (getPromse, stubContent) {
		var self = this;

		if (typeof getPromse !== 'function') {
			throw new Error('getPromse expected to be a function.');
		}

		self.isLoaded = ko.observable(false);

		self.content = ko.onDemandObservable(function () {
			self.content(stubContent || null);
			getPromse().done(function (result) {
				self.content(result);
				self.isLoaded(true);
			});
		}, this);
	}

	return LazyLoadItem;
});
